import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-14">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-block px-5 py-2 border border-foreground-200 rounded-full text-xs font-label font-medium text-foreground-500 bg-background-50 whitespace-nowrap">
          About The Platform
        </span>

        <h2 className="mt-8 font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-tight tracking-tight">
          A Smarter Way to<br />
          <span className="inline-flex items-center gap-2">
            <i className="ri-shopping-bag-3-line text-3xl md:text-4xl lg:text-5xl text-primary-500 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 flex items-center justify-center"></i>
            Discover Products
          </span>
          <br />
          You Will Love
        </h2>

        {/* Definition Box for Google Position Zero */}
        <div className="mt-10 p-8 md:p-10 bg-background-100 rounded-lg border border-background-200 text-left">
          <p className="text-sm font-label font-semibold text-foreground-400 uppercase tracking-wide mb-3">What is Superbuy Spreadsheet?</p>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
            A Superbuy Spreadsheet is an organized digital resource that helps shoppers discover, compare, and understand products across multiple categories. It curates product information, pricing data, and shopping guides into one accessible platform, making it easier to find exactly what you need without endless searching across different websites.
          </p>
        </div>

        <Link
          to="/superbuy-spreadsheet-guide"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 text-sm font-label font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          Read the Complete Guide
          <i className="ri-arrow-right-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
        </Link>
      </div>
    </section>
  );
}